import React from 'react'
import {
  ExclamationCircleFilled,
  QuestionCircleOutlined
} from '@ant-design/icons'
import { Tooltip, Flex } from 'hljd'
import { Link } from 'react-router'
import { getMerchantInfo, isSiDaTeam, isStoreAccount, isSiYiTeam } from '@util'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'
import { dGet } from '@core/utils'
import LoginSub from '@components/LocalMerchant/SiDa/Common/LoginSub'
import { corpImage } from '@components/Hotel/util'
import style from './index.module.less'
import ImgBox from '@common/ImgBox'
export default store => {
  return [
    {
      title: '案例名称',
      dataIndex: 'name',
      key: 'name',
      width: 400,
      render: (text, record) => {
        let { merchant } = record
        merchant = merchant || {}
        const isSelfPublish = merchant.id == getMerchantInfo().id
        const src =
          record.vertical_image ||
          record.cover_path ||
          'https://qnm.hunliji.com/Fkgr3Q93xWK3MLJrSS24vgA3Cjpo?imageView2/1/w/288/h/288'

        return (
          <>
            <div className={style.nameWrap}>
              <div style={{ position: 'relative', marginRight: '5px' }}>
                <ImgBox
                  imgs={corpImage(src, '1:1', 500)}
                  imgH={72}
                  imgW={72}
                  onPreview={
                    record.vertical_image || record.cover_path ? null : () => {}
                  }
                  // title={<div className={style.imgShadow}>{statusText}</div>}
                />
              </div>

              <div className={style.name}>
                <h5>
                  {record.status == 3 || record.is_sold_out == true ? (
                    <a>{record.title}</a>
                  ) : (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/example/detail_${record.id}/admin/true`}
                    >
                      {record.title}
                    </a>
                  )}
                </h5>

                {isSiDaTeam() &&
                  !isSelfPublish && (
                    <LoginSub
                      style={{
                        color: '#448afc',
                        fontSize: '12px',
                        lineHeight: 1
                      }}
                      storeId={merchant.m_store_id}
                    >
                      {dGet(record, 'merchant.name')}
                    </LoginSub>
                  )}

                {record.dream_tag == 1 && (
                  <div className={style.dreamTag}>喜橙婚礼</div>
                )}

                {record.is_special == 1 && (
                  <span
                    style={{
                      background: '#448afc',
                      color: '#fff',
                      padding: '1px 2px',
                      borderRadius: 2
                    }}
                  >
                    主店铺
                    <Tooltip
                      placement="topLeft"
                      title="该案例无法直接编辑，系统将自动同步主店铺的案例更新"
                      arrowPointAtCenter
                    >
                      <QuestionCircleOutlined
                        style={{ cursor: 'pointer', marginLeft: 2 }}
                      />
                    </Tooltip>
                  </span>
                )}
                <p
                  style={{
                    display:
                      store.key == 2 || store.key == 4
                        ? 'none'
                        : record.reason == '' || record.reason == null
                          ? 'none'
                          : 'block'
                  }}
                  className={style.tipBox}
                />
              </div>
            </div>
            {record.sensitive_tip && (
              <Flex
                style={{
                  marginTop: 18,
                  fontSize: 12,
                  color: '#FF4B4B'
                }}
              >
                <ExclamationCircleFilled
                  style={{
                    lineHeight: 2,
                    color: '#FF4B4B',
                    fontSize: 12,
                    marginRight: 4
                  }}
                />
                <p style={{ lineHeight: '22px' }}>{record.sensitive_tip}</p>
              </Flex>
            )}
          </>
        )
      }
    },
    {
      title: '成员',
      dataIndex: 'emcee_member',
      render: (text, record) => <div>{record?.emcee_member?.name}</div>,
      hidden: () => !isSiYiTeam()
    },
    {
      title: '类型',
      dataIndex: 'meal_type',
      render: meal_type => (meal_type == 1 ? '样片' : '客照'),
      hidden: () => {
        if (isStoreAccount()) {
          return +store.currentProperty !== 6
        } else {
          return !isWeddingDressPhotoProperty()
        }
      }
    },
    {
      title: (
        <span>
          关联客照&nbsp;
          <a href="#/localMerchant/case/introduce" style={{ color: '#ff8c30' }}>
            <QuestionCircleOutlined />
          </a>
        </span>
      ),
      dataIndex: 'sample_related_pic_count',
      render: (text, record) => {
        return record.meal_type == 1 ? (
          <Link to={'/localMerchant/case/unionPhoto/' + record.id}>
            已关联{text || '0'}张
          </Link>
        ) : (
          <span>-</span>
        )
      },
      hidden: () => {
        if (isStoreAccount()) {
          return +store.currentProperty !== 6
        } else {
          return !isWeddingDressPhotoProperty()
        }
      }
    },
    {
      title: '当前状态',
      key: 'state',
      width: 200,
      render: (text, { is_sold_out, is_never_sold }) => {
        if (is_never_sold == 1) {
          return '从未上架'
        }
        if (is_sold_out == 0) {
          return '已上架'
        } else {
          return '已下架'
        }
      }
    },
    {
      title: '最新发布时间',
      dataIndex: 'last_edit_at',
      render: (text, record) => <div>{record.last_edit_at}</div>
    },
    {
      title: '未通过原因',
      dataIndex: 'reason',
      width: 325,
      hidden: () => {
        return store.key != 3
      },
      render: text => {
        if (!text) {
          return '无'
        }
        const over = text.length > 40
        const t = text.slice(0, 40) + (over ? '...' : '')
        return over ? (
          <Tooltip placement="top" title={text}>
            {t}
          </Tooltip>
        ) : (
          t
        )
      }
    },
    {
      title: '违规说明',
      dataIndex: 'illegal_des',
      width: 325,
      hidden: () => {
        return store.key != 3 || !store.grayTestFlag || store.property_id !== 2
      },
      render: text => {
        if (!text) {
          return '无'
        }
        const over = text.length > 50
        const t = text.slice(0, 50) + (over ? '...' : '')
        return over ? (
          <Tooltip placement="top" title={text}>
            {t}
          </Tooltip>
        ) : (
          t
        )
      }
    },
    {
      title: '操作',
      dataIndex: 'edit',
      width: 140,
      align: 'center',
      render: (
        text,
        record //第一个tab和最后一个tab分上架下架，其他根据is_sold_out判断
      ) => {
        return (
          <p>
            <a style={{ color: '#508cee' }} onClick={store.toEdit(record)}>
              编辑
            </a>
          </p>
        )
      }
    }
  ]
}
